<template>
    <Layout>
        <PageHeader :title="title" :items="items"></PageHeader>
        <div class="row" id="series">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row align-items-center mb-4">
                <div class="col-md-6">
                  <div class="form-inline navbar-search">
                    <div class="input-group">
                      <input v-on:keyup="search" name="title" class="form-control bg-light border-0 small"
                        placeholder="Search Title" aria-label="Search" aria-describedby="basic-addon2" value=""
                        v-model="filter" />
                      <div class="input-group-append">
                        <button class="btn btn-search" @click="searchFor">
                          <i class="fas fa-search fa-sm"> </i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive mb-0">
                <b-table
                  :items="tableData.doctors"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  responsive
                  class="table-bordered table-hover"
                >
                  <template v-slot:cell(fname)="row">
                    {{ row.item.fname }} {{ row.item.lname }}
                  </template>

                  <template v-slot:cell(contact)="row">
                    <div>{{ row.item.mobile_number || "-" }}</div>
                    <small class="text-muted">{{ row.item.email || "" }}</small>
                  </template>

                  <template v-slot:cell(appointment_counts)="row">
                    <div class="stat-lines">
                      <span><b>Total:</b> {{ (row.item.appointment_counts || {}).total || 0 }}</span>
                      <span class="text-success">Completed: {{ (row.item.appointment_counts || {}).completed || 0 }}</span>
                      <span class="text-warning">In process: {{ (row.item.appointment_counts || {}).in_process || 0 }}</span>
                      <span class="text-danger">Cancelled: {{ (row.item.appointment_counts || {}).cancelled || 0 }}</span>
                    </div>
                  </template>

                  <template v-slot:cell(token_summary)="row">
                    <div class="stat-lines">
                      <span><b>Balance:</b> {{ (row.item.token_summary || {}).remaining || 0 }}</span>
                      <span>Used: {{ (row.item.token_summary || {}).used || 0 }}</span>
                      <span class="text-muted">Total: {{ (row.item.token_summary || {}).total || 0 }}</span>
                    </div>
                  </template>

                  <template v-slot:cell(wallet_summary)="row">
                    <div class="stat-lines">
                      <span><b>Balance:</b> {{ (row.item.wallet_summary || {}).remaining || 0 }}</span>
                      <span>Used: {{ (row.item.wallet_summary || {}).used || 0 }}</span>
                      <span class="text-muted">Total: {{ (row.item.wallet_summary || {}).total || 0 }}</span>
                    </div>
                  </template>

                  <template v-slot:cell(billing_summary)="row">
                    <div class="stat-lines">
                      <span><b>Bills:</b> {{ (row.item.billing_summary || {}).total_bills || 0 }}</span>
                      <span>Total: {{ (row.item.billing_summary || {}).total_amount || 0 }}</span>
                      <span class="text-success">Paid: {{ (row.item.billing_summary || {}).paid_amount || 0 }}</span>
                      <span class="text-danger">Balance: {{ (row.item.billing_summary || {}).balance_amount || 0 }}</span>
                    </div>
                  </template>
                </b-table>
              </div>
              <template v-if="tableData.last_page > 1">
                <div class="data_paginate">
                  
                  <div class="d-flex justify-content-end">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="tableData.total"
                      :per-page="tableData.size"
                      first-number
                      last-number
                    ></b-pagination>
                  </div>

                  <div class="form-inline mt-2">
                    <span class="mr-2">Go to page:</span>
                    <b-form-input v-model="pageNo" class="in-width"></b-form-input>
                    <button class="btn btn-search ml-2" @click="filterPage">
                      Go
                    </button>
                  </div>

                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import MixinRequest from "../../../mixins/request";
import wowDoctorMixin from "../../../mixins/ModuleJs/clinic-details";

export default {
    data() {
      return {
        title: "List Wow Doctors",
        sortBy: "_id",
        sortDesc: true,
        items: [
          {
            text: "Home",
            href: "/",
          },
          {
            text: "List",
          },
        ],
      };
    },
    mixins: [wowDoctorMixin, MixinRequest],
    components: {
      Layout,
      PageHeader,
    },
  };
</script>
<style scoped>
.stat-lines{
  display: flex;
  flex-direction: column;
  font-size: 15px;
  line-height: 1.4;
  white-space: nowrap;
}
</style>